import "bootstrap/dist/css/bootstrap.min.css";
import { onValue, push, ref, remove, update } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";

const JatiPrakar = () => {
  /* ================= DATA ================= */
  const [jatiPrakars, setJatiPrakars] = useState([]);
  const [upjatiPrakars, setUpjatiPrakars] = useState([]);
  const [gotras, setGotras] = useState([]);
  const [moors, setMoors] = useState([]);

  /* ================= FORM ================= */
  const [type, setType] = useState("");
  const [selectedJati, setSelectedJati] = useState("");
  const [selectedUpjati, setSelectedUpjati] = useState("");
  const [selectedGotra, setSelectedGotra] = useState("");
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ================= MODAL ================= */
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("jatiPrakars");

  /* ================= FETCH DATA ================= */
  useEffect(() => {
    const fetchData = (path, setter) =>
      onValue(ref(db, path), snap =>
        setter(
          snap.exists()
            ? Object.entries(snap.val()).map(([id, v]) => ({ id, ...v }))
            : []
        )
      );

    fetchData("masters/jatiPrakars", setJatiPrakars);
    fetchData("masters/upjatiPrakars", setUpjatiPrakars);
    fetchData("masters/gotras", setGotras);
    fetchData("masters/moors", setMoors);
  }, []);

  /* ================= HELPERS ================= */
  const exists = (list, condition) =>
    list.some(item =>
      Object.keys(condition).every(k => item[k] === condition[k])
    );

  const resetForm = () => {
    setEditId(null);
    setSelectedJati("");
    setSelectedUpjati("");
    setSelectedGotra("");
    setName("");
  };

  const openModal = (t, row = null) => {
    setType(t);
    resetForm();

    if (row) {
      setEditId(row.id);
      setSelectedJati(row.jatiPrakar || "");
      setSelectedUpjati(row.upjatiPrakar || "");
      setSelectedGotra(row.gotra || "");
      setName(row.name || "");
    }
    setShowModal(true);
  };

  // Filter upjatiPrakars based on selected jatiPrakar
  const filteredUpjatiPrakars = selectedJati
    ? upjatiPrakars.filter(u => u.jatiPrakar === selectedJati)
    : [];

  // Filter gotras based on selected jatiPrakar and upjatiPrakar
  const filteredGotras = selectedJati && selectedUpjati
    ? gotras.filter(g => g.jatiPrakar === selectedJati && g.upjatiPrakar === selectedUpjati)
    : [];

  /* ================= DELETE ================= */
  const handleDelete = async (id, typeToDelete) => {
    if (!window.confirm('क्या आप वाकई इस आइटम को हटाना चाहते हैं?')) return;
    
    setLoading(true);
    try {
      if (typeToDelete === "jatiPrakar") {
        await remove(ref(db, `masters/jatiPrakars/${id}`));
      } else if (typeToDelete === "upjatiPrakar") {
        await remove(ref(db, `masters/upjatiPrakars/${id}`));
      } else if (typeToDelete === "gotra") {
        await remove(ref(db, `masters/gotras/${id}`));
      } else if (typeToDelete === "moor") {
        await remove(ref(db, `masters/moors/${id}`));
      }
      alert('आइटम सफलतापूर्वक हटा दिया गया ✅');
    } catch (err) {
      console.error(err);
      alert('डिलीट करने में त्रुटि हुई ❌');
    } finally {
      setLoading(false);
    }
  };

  /* ================= SAVE ================= */
  const handleSave = async () => {
    if (!name.trim()) return alert("नाम आवश्यक है");

    setLoading(true);
    try {
      if (type === "jatiPrakar") {
        if (!editId && exists(jatiPrakars, { name }))
          return alert("यह जाति प्रकार पहले से मौजूद है");

        const data = { name: name.trim() };
        editId
          ? await update(ref(db, `masters/jatiPrakars/${editId}`), data)
          : await push(ref(db, "masters/jatiPrakars"), data);
      }

      if (type === "upjatiPrakar") {
        if (!selectedJati) return alert("जाति प्रकार चुनें");
        if (!editId && exists(upjatiPrakars, { jatiPrakar: selectedJati, name }))
          return alert("यह उपजाति प्रकार पहले से मौजूद है");

        const data = { jatiPrakar: selectedJati, name: name.trim() };
        editId
          ? await update(ref(db, `masters/upjatiPrakars/${editId}`), data)
          : await push(ref(db, "masters/upjatiPrakars"), data);
      }

      if (type === "gotra") {
        if (!selectedJati || !selectedUpjati) return alert("जाति प्रकार और उपजाति प्रकार चुनें");
        if (!editId && exists(gotras, { jatiPrakar: selectedJati, upjatiPrakar: selectedUpjati, name }))
          return alert("यह गोत्र/वंश/अन्य पहले से मौजूद है");

        const data = { 
          jatiPrakar: selectedJati, 
          upjatiPrakar: selectedUpjati, 
          name: name.trim()
        };
        editId
          ? await update(ref(db, `masters/gotras/${editId}`), data)
          : await push(ref(db, "masters/gotras"), data);
      }

      if (type === "moor") {
        if (!selectedJati || !selectedUpjati || !selectedGotra) return alert("जाति प्रकार, उपजाति प्रकार और गोत्र चुनें");
        if (!editId && exists(moors, { jatiPrakar: selectedJati, upjatiPrakar: selectedUpjati, gotra: selectedGotra, name }))
          return alert("यह मूर पहले से मौजूद है");

        const data = { 
          jatiPrakar: selectedJati, 
          upjatiPrakar: selectedUpjati, 
          gotra: selectedGotra,
          name: name.trim()
        };
        editId
          ? await update(ref(db, `masters/moors/${editId}`), data)
          : await push(ref(db, "masters/moors"), data);
      }

      resetForm();
      setShowModal(false);
      alert('सफलतापूर्वक सेव किया गया ✅');
    } catch (err) {
      console.error(err);
      alert("सेव करने में त्रुटि हुई ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h4>🏛️ जाति प्रकार मास्टर</h4>

      {/* Tabs for navigation */}
      <ul className="nav nav-tabs mb-4" role="tablist">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "jatiPrakars" ? "active" : ""}`}
            onClick={() => setActiveTab("jatiPrakars")}
          >
            जाति प्रकार ({jatiPrakars.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "upjatiPrakars" ? "active" : ""}`}
            onClick={() => setActiveTab("upjatiPrakars")}
          >
            उपजाति प्रकार ({upjatiPrakars.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "gotras" ? "active" : ""}`}
            onClick={() => setActiveTab("gotras")}
          >
            गोत्र/वंश/अन्य ({gotras.length})
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === "moors" ? "active" : ""}`}
            onClick={() => setActiveTab("moors")}
          >
            मूर ({moors.length})
          </button>
        </li>
      </ul>

      {/* Jati Prakar Table */}
      {activeTab === "jatiPrakars" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>जाति प्रकार <span className="badge bg-info ms-2">कुल: {jatiPrakars.length}</span></h5>
            <button
              className="btn btn-sm btn-success"
              onClick={() => openModal("jatiPrakar")}
            >
              + जाति प्रकार जोड़ें
            </button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ width: "50px" }}>क्रम</th>
                <th>जाति प्रकार का नाम</th>
                <th style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {jatiPrakars.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted">
                    कोई डेटा नहीं मिला
                  </td>
                </tr>
              ) : (
                jatiPrakars.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.name || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => openModal("jatiPrakar", row)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id, "jatiPrakar")}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Upjati Prakar Table */}
      {activeTab === "upjatiPrakars" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>उपजाति प्रकार <span className="badge bg-info ms-2">कुल: {upjatiPrakars.length}</span></h5>
            <button
              className="btn btn-sm btn-success"
              onClick={() => openModal("upjatiPrakar")}
            >
              + उपजाति प्रकार जोड़ें
            </button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ width: "50px" }}>क्रम</th>
                <th>जाति प्रकार</th>
                <th>उपजाति प्रकार का नाम</th>
                <th style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {upjatiPrakars.length === 0 ? (
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    कोई डेटा नहीं मिला
                  </td>
                </tr>
              ) : (
                upjatiPrakars.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.jatiPrakar || "-"}</td>
                    <td>{row.name || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => openModal("upjatiPrakar", row)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id, "upjatiPrakar")}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Gotra Table */}
      {activeTab === "gotras" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>गोत्र/वंश/अन्य <span className="badge bg-info ms-2">कुल: {gotras.length}</span></h5>
            <button
              className="btn btn-sm btn-success"
              onClick={() => openModal("gotra")}
            >
              + गोत्र/वंश/अन्य जोड़ें
            </button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ width: "50px" }}>क्रम</th>
                <th>जाति प्रकार</th>
                <th>उपजाति प्रकार</th>
                <th>गोत्र/वंश/अन्य का नाम</th>
                <th style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {gotras.length === 0 ? (
                <tr>
                  <td colSpan={5} className="text-center text-muted">
                    कोई डेटा नहीं मिला
                  </td>
                </tr>
              ) : (
                gotras.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.jatiPrakar || "-"}</td>
                    <td>{row.upjatiPrakar || "-"}</td>
                    <td>{row.name || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => openModal("gotra", row)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id, "gotra")}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Moor Table */}
      {activeTab === "moors" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>मूर <span className="badge bg-info ms-2">कुल: {moors.length}</span></h5>
            <button
              className="btn btn-sm btn-success"
              onClick={() => openModal("moor")}
            >
              + मूर जोड़ें
            </button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark">
              <tr>
                <th style={{ width: "50px" }}>क्रम</th>
                <th>जाति प्रकार</th>
                <th>उपजाति प्रकार</th>
                <th>गोत्र/वंश/अन्य</th>
                <th>मूर का नाम</th>
                <th style={{ width: "120px" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {moors.length === 0 ? (
                <tr>
                  <td colSpan={6} className="text-center text-muted">
                    कोई डेटा नहीं मिला
                  </td>
                </tr>
              ) : (
                moors.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.jatiPrakar || "-"}</td>
                    <td>{row.upjatiPrakar || "-"}</td>
                    <td>{row.gotra || "-"}</td>
                    <td>{row.name || "-"}</td>
                    <td style={{ whiteSpace: "nowrap" }}>
                      <div className="d-flex gap-1">
                        <button
                          className="btn btn-sm btn-warning"
                          onClick={() => openModal("moor", row)}
                        >
                          ✏️ Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => handleDelete(row.id, "moor")}
                        >
                          🗑️ Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Modal for Add/Edit */}
      {showModal && (
        <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {type === "jatiPrakar" && (editId ? "जाति प्रकार संपादित करें" : "जाति प्रकार जोड़ें")}
                  {type === "upjatiPrakar" && (editId ? "उपजाति प्रकार संपादित करें" : "उपजाति प्रकार जोड़ें")}
                  {type === "gotra" && (editId ? "गोत्र/वंश/अन्य संपादित करें" : "गोत्र/वंश/अन्य जोड़ें")}
                  {type === "moor" && (editId ? "मूर संपादित करें" : "मूर जोड़ें")}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                  disabled={loading}
                ></button>
              </div>
              <div className="modal-body">
                {type === "jatiPrakar" && (
                  <div className="mb-3">
                    <label className="form-label">जाति प्रकार का नाम *</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="जाति प्रकार का नाम दर्ज करें"
                      disabled={loading}
                    />
                  </div>
                )}

                {type === "upjatiPrakar" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">जाति प्रकार चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedJati}
                        onChange={(e) => setSelectedJati(e.target.value)}
                        disabled={loading}
                      >
                        <option value="">-- जाति प्रकार चुनें --</option>
                        {jatiPrakars.map((jati) => (
                          <option key={jati.id} value={jati.name}>
                            {jati.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">उपजाति प्रकार का नाम *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="उपजाति प्रकार का नाम दर्ज करें"
                        disabled={loading}
                      />
                    </div>
                  </>
                )}

                {type === "gotra" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">जाति प्रकार चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedJati}
                        onChange={(e) => {
                          setSelectedJati(e.target.value);
                          setSelectedUpjati("");
                        }}
                        disabled={loading}
                      >
                        <option value="">-- जाति प्रकार चुनें --</option>
                        {jatiPrakars.map((jati) => (
                          <option key={jati.id} value={jati.name}>
                            {jati.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">उपजाति प्रकार चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedUpjati}
                        onChange={(e) => setSelectedUpjati(e.target.value)}
                        disabled={loading || !selectedJati}
                      >
                        <option value="">-- उपजाति प्रकार चुनें --</option>
                        {filteredUpjatiPrakars.map((upjati) => (
                          <option key={upjati.id} value={upjati.name}>
                            {upjati.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">गोत्र/वंश/अन्य का नाम *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="गोत्र/वंश/अन्य का नाम दर्ज करें"
                        disabled={loading}
                      />
                    </div>
                  </>
                )}

                {type === "moor" && (
                  <>
                    <div className="mb-3">
                      <label className="form-label">जाति प्रकार चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedJati}
                        onChange={(e) => {
                          setSelectedJati(e.target.value);
                          setSelectedUpjati("");
                          setSelectedGotra("");
                        }}
                        disabled={loading}
                      >
                        <option value="">-- जाति प्रकार चुनें --</option>
                        {jatiPrakars.map((jati) => (
                          <option key={jati.id} value={jati.name}>
                            {jati.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">उपजाति प्रकार चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedUpjati}
                        onChange={(e) => {
                          setSelectedUpjati(e.target.value);
                          setSelectedGotra("");
                        }}
                        disabled={loading || !selectedJati}
                      >
                        <option value="">-- उपजाति प्रकार चुनें --</option>
                        {filteredUpjatiPrakars.map((upjati) => (
                          <option key={upjati.id} value={upjati.name}>
                            {upjati.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">गोत्र/वंश/अन्य चुनें *</label>
                      <select
                        className="form-select"
                        value={selectedGotra}
                        onChange={(e) => setSelectedGotra(e.target.value)}
                        disabled={loading || !selectedJati || !selectedUpjati}
                      >
                        <option value="">-- गोत्र/वंश/अन्य चुनें --</option>
                        {filteredGotras.map((gotra) => (
                          <option key={gotra.id} value={gotra.name}>
                            {gotra.name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">मूर का नाम *</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="मूर का नाम दर्ज करें"
                        disabled={loading}
                      />
                    </div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={loading}
                >
                  {loading ? "सेव कर रहे हैं..." : editId ? "Update" : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JatiPrakar;